<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/c8m8je/images/9780374304836.jpg?1720280501173" alt="This image is the cover for the book Hideout"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hideout
      </h1>
      <p class="bookDescription body article font2">
        <p>In this riveting middle-grade adventure, the son of a Mississippi policeman finds a boy living on his own in the wilderness. Twelve-year-old Sam has been given a fishing boat by his father, but he hates fishing. Instead he uses the boat to disappear for hours at a time, exploring the forbidden swampy surroundings of his bayou home. Then he discovers a strange kid named Davey, mysteriously alone, repairing an abandoned cabin deep in the woods. Not fooled by the boy’s evasive explanation as to why he’s on his own, Sam becomes entangled in his own efforts to help Davey. But this leads him to telling small lies that only get bigger as the danger increases for both boys and hidden truths become harder to conceal.<br/><br/>This title has Common Core connections.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Watt Key
      </h2>
      
      <p class="authorDescription body article">Watt Key lives in southern Alabama with his family. His debut novel, <I>Alabama Moon</I>, was named to <I>Time Magazine</I>’s list of the Best One Hundred YA Books of All Time. <I>Hideout</I> is his fifth book for young readers.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4299079e